import { render, staticRenderFns } from "./TSelectQuestionModal.vue?vue&type=template&id=36ada959&scoped=true"
import script from "./TSelectQuestionModal.vue?vue&type=script&lang=js"
export * from "./TSelectQuestionModal.vue?vue&type=script&lang=js"
import style0 from "./TSelectQuestionModal.vue?vue&type=style&index=0&id=36ada959&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ada959",
  null
  
)

export default component.exports